import { XIcon } from '@heroicons/react/outline'
import { useEffect } from 'react'

const FormSuccessDialog = ({ toggleModal, userType }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <>
      <div
        onClick={() => toggleModal(false)}
        className="fixed inset-0 z-10 flex items-center justify-center w-full h-full bg-black-default/10"
      >
        <div className="grid w-full h-full grid-cols-1 px-5 py-10 overflow-auto text-center border-white border-solid md:w-3/5 md:h-2/4 border-1 bg-white-light text-blue">
          <div>
            <button
              onClick={() => toggleModal(false)}
              className="absolute top-5 right-5"
            >
              <XIcon className="w-6 h-6" aria-hidden="true" />
            </button>
            <div className="flex flex-col items-center justify-between w-full h-full md:p-0 pt-36">
              {userType === 'individual' || userType === 'broker' ? (
                <>
                  <h4 className="text-3xl md:text-5xl mb-11">
                    Thank you for your interest.
                  </h4>
                  <p className="mb-12 text-xl leading-10">
                    Evry is currently only available for employers. <br />
                    We will let you know as soon as it is available for
                    individuals.
                  </p>
                  <a
                    href="mailto:contact@evryhealth.com"
                    onClick={() => toggleModal(false)}
                    className="inline-block px-6 py-2 text-lg font-medium bg-green text-white-light hover:bg-blue"
                  >
                    Tell your employer about Evry
                  </a>
                </>
              ) : (
                <>
                  <h2 className="text-3xl md:text-5xl mb-11">
                    Thanks for{' '}
                    <span className="inline-block">contacting us.</span>
                  </h2>
                  <p className="mb-12 text-xl leading-10 xl:whitespace-nowrap">
                    We will be in touch very soon.
                  </p>
                  <button
                    className="w-48 px-12 py-2 text-lg font-medium text-white bg-green"
                    onClick={() => toggleModal(false)}
                  >
                    Close
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FormSuccessDialog
